import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './plugins/i18n'
import VueThailandAddress from '@/plugins/vue-thailand-address'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import VueToastr from 'vue-toastr'
import Clipboard from 'v-clipboard'
import Cookies from 'js-cookie'
import VueSweetalert2 from 'vue-sweetalert2'
import { BootstrapVue } from 'bootstrap-vue'

import storeIndex from './store/index'
import Vuex from 'vuex'
import config from './settings.js'
import { store as vuexStore } from './vuex-store'

import ThaiAddressInput from '@/plugins/vue-thai-address-input/dist/vue-thai-address-input.esm.js';
require('@/plugins/vue-thai-address-input/dist/vue-thai-address-input.min.css');

import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import VueApexCharts from 'vue-apexcharts'
import VueRecaptcha from 'vue-recaptcha'

Vue.use(VuePlyr, {
  plyr: {}
})

Vue.prototype.$config = config
Vue.prototype.$storeIndex = storeIndex
Vue.prototype.$cookie = Cookies
Vue.use(Clipboard)
Vue.use(VueSweetalert2)
Vue.use(VueThailandAddress);
Vue.use(ThaiAddressInput);
Vue.config.productionTip = false
Vue.directive('tooltip', function (el, binding) {
  $(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover'
  })
})
Vue.directive('clickoutside', {
  inserted: (el, binding, vnode) => {
    // assign event to the element
    el.clickOutsideEvent = function (event) {
      // here we check if the click event is outside the element and it's children
      if (!(el == event.target || el.contains(event.target))) {
        // if clicked outside, call the provided method
        vnode.context[binding.expression](event)
      }
    }
    // register click and touch events
    document.body.addEventListener('click', el.clickOutsideEvent)
    document.body.addEventListener('touchstart', el.clickOutsideEvent)
  },
  unbind: function (el) {
    // unregister click and touch events before the element is unmounted
    document.body.removeEventListener('click', el.clickOutsideEvent)
    document.body.removeEventListener('touchstart', el.clickOutsideEvent)
  },
  stopProp(event) {
    event.stopPropagation()
  }
})
Vue.use(Vuelidate)
Vue.use(VueToastr, {
  defaultTimeout: 8000,
  defaultProgressBar: true,
  defaultPosition: 'toast-top-right',
  defaultClickClose: false
})
Vue.use(VueThailandAddress)

const publicOnlyRouteNames = ['login', 'signup']

export const globalData = Vue.observable({
  conversations: [],
})

router.beforeEach((to, from, next) => {
  Vue.prototype.$setLayout = to

  if (to.name === 'gosaas-connect') {
    if (to.query.token && to.query.subdomain && to.query.next) return next()

    console.log(
      '"next", "token", and "subdomain" query parameters are required'
    )

    return next('/')
  }

  if (to.query.token && to.query.subdomain) {
    return next({
      name: 'gosaas-connect',
      query: { ...to.query, next: to.path }
    })
  }

  // if (publicOnlyRouteNames.indexOf(to.name) !== -1) {
  //     // Accessing public-only route
  //     if (vuexStore.state.auth.isLoggedIn) return next('/')

  //     return next()
  // }

  // Accessing private route

  //   if (!vuexStore.state.auth.isLoggedIn) return next({ name: 'login' })

  next()
})
Vue.use(BootstrapVue)
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-recaptcha', VueRecaptcha)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  axios,
  VueToastr,
  store: vuexStore,
  Vuex,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js